import { LoruleRequestConfig } from '@galaxy/lorule-react-commons';
import { callWebUtils, commonHeaders } from './commonApiUtil';

/* Only in Draft status by creator or project manager, action requested and justification is required */
export const submitActionMemo = async (config: LoruleRequestConfig, amId: number) =>
    callWebUtils(
        config,
        `/actionmemo/${amId}/workflow`,
        'PATCH',
        JSON.stringify({
            processType: 'SUBMIT_AM',
        }),
        commonHeaders,
    );

/* Only in Pending status by current approver */
export const approveActionMemo = async (
    config: LoruleRequestConfig,
    amId: number,
    commentMessage?: string | null,
) =>
    callWebUtils(
        config,
        `/actionmemo/${amId}/workflow`,
        'PATCH',
        JSON.stringify({
            processType: 'APPROVE_AM',
            commentMessage,
        }),
        commonHeaders,
    );

/* Only in Pending status by current approver, comment is required */
export const returnActionMemo = async (
    config: LoruleRequestConfig,
    amId: number,
    commentMessage: string,
) =>
    callWebUtils(
        config,
        `/actionmemo/${amId}/workflow`,
        'PATCH',
        JSON.stringify({
            processType: 'RETURN_AM',
            commentMessage,
        }),
        commonHeaders,
    );

/* Only in Pending status by current approver */
export const skipActionMemo = async (
    config: LoruleRequestConfig,
    amId: number,
    commentMessage?: string | null,
) =>
    callWebUtils(
        config,
        `/actionmemo/${amId}/workflow`,
        'PATCH',
        JSON.stringify({
            processType: 'SKIP_AM',
            commentMessage,
        }),
        commonHeaders,
    );

/* Only in Pending status by admin */
export const holdActionMemo = async (
    config: LoruleRequestConfig,
    amId: number,
    commentMessage?: string | null,
) =>
    callWebUtils(
        config,
        `/actionmemo/${amId}/workflow`,
        'PATCH',
        JSON.stringify({
            processType: 'HOLD_AM',
            commentMessage,
        }),
        commonHeaders,
    );

/* Only in Hold status by admin */
export const releaseActionMemo = async (
    config: LoruleRequestConfig,
    amId: number,
    commentMessage?: string | null,
) =>
    callWebUtils(
        config,
        `/actionmemo/${amId}/workflow`,
        'PATCH',
        JSON.stringify({
            processType: 'RELEASE_AM',
            commentMessage,
        }),
        commonHeaders,
    );
